import { render, staticRenderFns } from "./SiteLayout.vue?vue&type=template&id=3ed199f9&scoped=true&"
import script from "./SiteLayout.vue?vue&type=script&lang=js&"
export * from "./SiteLayout.vue?vue&type=script&lang=js&"
import style0 from "./SiteLayout.vue?vue&type=style&index=0&id=3ed199f9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed199f9",
  null
  
)

export default component.exports